import { INadelThemeExtension } from "./theme.nadel.extension.d";

export function nadelThemeExtension(...themes: INadelThemeExtension[]) {
  return themes.reduce(
    (acc, i) => ({
      light: { ...acc.light, ...i.light },
      dark: { ...acc.dark, ...i.dark },
    }),
    { light: {}, dark: {} }
  );
}
